import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-notifications-counter',
  templateUrl: './notifications-counter.component.html',
  styleUrls: ['./notifications-counter.component.scss'],
})
export class NotificationsCounterComponent {
  @Input({ required: true }) public notificationNumber: number;
  @Input({ required: true }) public informationalNotificationsNumber: number;

  @Output() public onDismissAllEmitter: EventEmitter<void> = new EventEmitter<void>();

  public onDismissAll(): void {
    this.onDismissAllEmitter.emit();
  }
}
